import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { RadioContainer, RollingLoader, ToggleSwitch } from "../../../commons";
import { returnInputFieldLength } from "../../../../utils/commonFunctions";
import { RadioTypes } from "../../../../commonTypes/universalTypes";
import Select from "react-select";
import { DropDownType } from "../../../../commonTypes/clientDirectoryTypes";


type AppProps = {
  showAddEditMasterDataModal: boolean;
  isEdit: boolean;
  handleAddAndUpdate: () => void;
  handleInputChange: (data: any) => void;
  toggleAddEditMasterDataModal: () => void;
  inputFieldName: string;
  inputFieldError: string;
  fieldLabel: string;
  AddButtonName: string;
  UpdateButtonName: string;
  handleToogleStatusChange?: () => void;
  status: boolean;
  inputUniqueCheck?: number | null;
  fetching?: boolean;
  modalHeader?: string;
  toggleStatus?: boolean;
  UniqueCheckErrorMessage?: string;
  type?: string;
  handleSetRadioValue: (id: string) => void;
  radioType: string;
  radioOptions: RadioTypes[];
  departmentText: string;
  checkDepartmentBottom: (e: any) => void;
  selectedDepartment: DropDownType[] | [];
  setSelectedDepartment: React.Dispatch<React.SetStateAction<DropDownType[] | []>>;
  finalSelectedDepartment: DropDownType[] | [];
  setFinalSelectedDepartment: React.Dispatch<React.SetStateAction<DropDownType[] | []>>;
  departmentFetching: boolean;
  setDepartmentOffset: React.Dispatch<React.SetStateAction<number>> | undefined;
  finalDepartmentList: DropDownType[] | [];
  setDepartmentText: React.Dispatch<React.SetStateAction<string>>;
};

const AddEditMasterJobTitleModal = ({
  showAddEditMasterDataModal,
  toggleAddEditMasterDataModal,
  isEdit,
  inputFieldName,
  inputFieldError,
  handleAddAndUpdate,
  handleInputChange,
  handleToogleStatusChange,
  status,
  fieldLabel,
  UpdateButtonName,
  AddButtonName,
  inputUniqueCheck,
  fetching,
  modalHeader,
  toggleStatus,
  UniqueCheckErrorMessage,
  type,
  handleSetRadioValue,
  radioType,
  radioOptions,
  departmentText,
  checkDepartmentBottom,
  selectedDepartment,
  setSelectedDepartment,
  departmentFetching,
  setDepartmentOffset,
  finalDepartmentList,
  setDepartmentText,
}: AppProps) => {

  const handleDepartmentDropDownChange = (e: any) => {
    setSelectedDepartment(e);
  };

  return (
    <Modal
      isOpen={showAddEditMasterDataModal}
      toggle={toggleAddEditMasterDataModal}
    >
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} ${modalHeader}`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <form>
          <div className="form-group mt-3">
            <div>
              <label
                htmlFor="foldername"
                className={inputFieldName ? "active" : ""}
              >
                {fieldLabel} <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative">
                <input
                  type={"text"}
                  className={`form-control ${!!inputFieldError ? "error-border" : null
                    }`}
                  name="text"
                  value={inputFieldName}
                  autoFocus
                  onChange={(e) => handleInputChange(e)}
                  maxLength={60}
                  onKeyPress={(e: any) =>
                    e.key === "Enter" ? handleAddAndUpdate() : null
                  }
                />

                {fetching && <RollingLoader />}
              </div>
              {inputUniqueCheck === 1 && (
                <small className="text-danger">{UniqueCheckErrorMessage}</small>
              )}
            </div>
            {type !== "scopeOfWork" ? (
              <span className="input-length">
                {returnInputFieldLength(inputFieldName?.length, 60)}
              </span>
            ) : (
              ""
            )}
          </div>

          <div>
            <div className="col-md-12 p-0">
              <label className="mb-1 mt-2" htmlFor="">
                Department
                <span className="color-red">*</span>
              </label>

              <Select
                className="dropdown"
                placeholder={"Select..."}
                value={selectedDepartment}
                options={finalDepartmentList}
                isMulti
                isClearable
                onChange={(e) => handleDepartmentDropDownChange?.(e)}
                isSearchable={true}
                isLoading={departmentFetching && (departmentText?.length || 0) > 0}
                onMenuClose={() => setDepartmentOffset?.(0)}
                onMenuScrollToBottom={(e: any) => checkDepartmentBottom(e)}
                onInputChange={(e) => {
                  setDepartmentText?.(e);
                }}
              />
            </div>
          </div>

          <div className="mt-3">

            <label htmlFor="jobTitleType" className="mb-2">Type</label>
            <RadioContainer
              optionsList={radioOptions}
              handleSetRadioValue={handleSetRadioValue}
              radioValue={radioType}
              alignment="horizontal"
            />
          </div>

        </form>
      </ModalBody>
      <ModalFooter>
        <span className="pointer" onClick={toggleAddEditMasterDataModal}>
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleAddAndUpdate();
            toggleAddEditMasterDataModal();
          }}
          disabled={
            inputFieldName?.trim().length === 0 || inputUniqueCheck === 1 || selectedDepartment?.length === 0
          }
        >
          {isEdit ? UpdateButtonName : AddButtonName}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEditMasterJobTitleModal;
